import {ErrorMessage, Form, Formik} from "formik";
import React, {useState} from "react";
import {EmployeeLayout} from "../EmployeeLayout/EmployeeLayout";
import classes from './complaint.module.css';
import * as Yup from 'yup';
import {authAxios} from "../../../API/apiRequest";
import {toast, ToastContainer} from "material-react-toastify";
import {Loading} from "../../../components/Loading/Loading";
import TextField from "../../../components/TextField/TextField";
import {TextArea} from "../../../components/TextArea/TextArea";
import {Button} from "../../../components/Button/Button";

export const Complaint: React.FC = () => {


    const [load, setload] = useState<boolean>();
    return (<>
        <EmployeeLayout>
            <div className="rtl">
                <ToastContainer
                    closeOnClick={false}
                    autoClose={1000}
                    pauseOnHover
                    newestOnTop
                    hideProgressBar={false}
                    position="bottom-right" rtl/>
                {load ? (
                    <div>
                        <Loading/>
                    </div>
                ) : (<>
                    <Formik
                        initialValues={{title: "", message: ""}}
                        validationSchema={Yup.object().shape({

                            title: Yup.string().required('برجاء ادخل عنوان شكواك'),
                            message: Yup.string().required("الرجاء إدخال شكواك"),
                        })}
                        onSubmit={(values) => {

                            setload(true)
                            try {
                                authAxios.post(`/report `, values).then(res => {
                                    if (res.status === 200 || res.status === 201) {

                                        toast.success("تم ارسال شكواك");
                                        setload(false)
                                    }

                                })
                            } catch (err) {

                            }


                        }}

                    >
                        {({values, setFieldValue}) => (
                            <Form>
                                <div className={classes.inputForm}>

                                    <TextField
                                        iconName='FiUser'
                                        value={values.title}
                                        handleChange={(event) => setFieldValue("title", event.target.value)}
                                        placeholder='العنوان'
                                        containerStyle={{margin: 8}}
                                        width={270}
                                    />
                                    <ErrorMessage name="title" className={classes.TextError} component="div"/>

                                    <TextArea
                                        placeholder={'... رسالتك'}
                                        style={{margin: '8px'}}
                                        value={values.message}
                                        handleChange={(event) => setFieldValue("message", event.target.value)}
                                        width={300}
                                    />
                                    <ErrorMessage name="message" className={classes.TextError} component="div"/>

                                    <Button color='#5A8D59' style={{margin: 8}}>إرسال</Button>

                                </div>
                            </Form>
                        )}
                    </Formik> </>)}
            </div>
        </EmployeeLayout>
    </>)
}